import { WalletConnect } from '@thirdweb-dev/wallets';
import { useCreateWalletInstance, useWalletContext, useConnect } from '@thirdweb-dev/react-core';
import { useState, useRef, useEffect } from 'react';
import { S as ScanScreen, i as isMobile, C as ConnectingScreen, G as GetStartedScreen } from './headlessConnectUI-a21ee0ae.browser.esm.js';
import { jsx } from 'react/jsx-runtime';
import { W as WCOpenURI, h as handelWCSessionRequest } from './handleWCSessionRequest-02ea6063.browser.esm.js';
import './basic-344e3cc9.browser.esm.js';
import '@emotion/react';
import '@emotion/styled';
import '@radix-ui/colors';
import 'detect-browser';
import 'react-qr-code';
import '@radix-ui/react-dialog';
import '@radix-ui/react-icons';

const RainbowScan = _ref => {
  let {
    onBack,
    onConnected,
    onGetStarted,
    walletConfig,
    hideBackButton
  } = _ref;
  const createInstance = useCreateWalletInstance();
  const [qrCodeUri, setQrCodeUri] = useState();
  const {
    setConnectedWallet,
    chainToConnect,
    setConnectionStatus
  } = useWalletContext();
  const scanStarted = useRef(false);
  useEffect(() => {
    if (scanStarted.current) {
      return;
    }
    scanStarted.current = true;
    const rainbow = createInstance(walletConfig);
    setConnectionStatus("connecting");
    rainbow.connectWithQrCode({
      chainId: chainToConnect?.chainId,
      onQrCodeUri(uri) {
        setQrCodeUri(uri);
      },
      onConnected() {
        setConnectedWallet(rainbow);
        onConnected();
      }
    });
  }, [createInstance, setConnectedWallet, chainToConnect, onConnected, walletConfig, setConnectionStatus]);
  return /*#__PURE__*/jsx(ScanScreen, {
    onBack: onBack,
    onGetStarted: onGetStarted,
    qrCodeUri: qrCodeUri,
    walletName: walletConfig.meta.name,
    walletIconURL: walletConfig.meta.iconURL,
    hideBackButton: hideBackButton
  });
};

const RainbowConnectUI = props => {
  const [screen, setScreen] = useState("connecting");
  const {
    walletConfig,
    close
  } = props;
  const connect = useConnect();
  const hideBackButton = props.supportedWallets.length === 1;
  const {
    goBack
  } = props;
  const connectPrompted = useRef(false);
  useEffect(() => {
    if (connectPrompted.current) {
      return;
    }

    // if loading
    (async () => {
      // on mobile, open rainbow app link
      if (isMobile()) {
        setScreen("open-wc-uri");
      } else {
        // on desktop, show the rainbow scan qr code
        setScreen("scanning");
      }
    })();
  }, [walletConfig, close, connect, goBack]);
  if (screen === "connecting") {
    return /*#__PURE__*/jsx(ConnectingScreen, {
      hideBackButton: hideBackButton,
      onBack: props.goBack,
      walletName: walletConfig.meta.name,
      walletIconURL: walletConfig.meta.iconURL,
      supportLink: "https://rainbow.me/"
    });
  }
  if (screen === "open-wc-uri") {
    return /*#__PURE__*/jsx(WCOpenURI, {
      hideBackButton: hideBackButton,
      onBack: props.goBack,
      onConnected: close,
      walletConfig: walletConfig,
      supportLink: "https://rainbow.me/",
      appUriPrefix: {
        ios: "rainbow://",
        android: "https://rnbwapp.com/",
        other: "https://rnbwapp.com/"
      }
    });
  }
  if (screen === "get-started") {
    return /*#__PURE__*/jsx(GetStartedScreen, {
      walletIconURL: walletConfig.meta.iconURL,
      walletName: walletConfig.meta.name,
      chromeExtensionLink: walletConfig.meta.urls?.chrome,
      googlePlayStoreLink: walletConfig.meta.urls?.android,
      appleStoreLink: walletConfig.meta.urls?.ios,
      onBack: () => {
        setScreen("scanning");
      }
    });
  }
  if (screen === "scanning") {
    return /*#__PURE__*/jsx(RainbowScan, {
      onBack: props.goBack,
      onConnected: close,
      onGetStarted: () => {
        setScreen("get-started");
      },
      hideBackButton: hideBackButton,
      walletConfig: walletConfig
    });
  }
  return null;
};

const rainbowWalletUris = {
  ios: "rainbow://",
  android: "https://rnbwapp.com/",
  other: "https://rnbwapp.com/"
};

const rainbowWallet = options => {
  return {
    id: "rainbow",
    meta: {
      name: "Rainbow Wallet",
      iconURL: "ipfs://QmSZn47p4DVVBfzvg9BAX2EqwnPxkT1YAE7rUnrtd9CybQ/rainbow-logo.png",
      urls: {
        android: "https://rnbwapp.com/e/Va41HWS6Oxb",
        ios: "https://rnbwapp.com/e/OeMdmkJ6Oxb"
      }
    },
    create: walletOptions => {
      const wallet = new WalletConnect({
        ...walletOptions,
        walletId: "rainbow",
        projectId: options?.projectId,
        qrcode: false
      });
      handelWCSessionRequest(wallet, rainbowWalletUris);
      return wallet;
    },
    connectUI: RainbowConnectUI,
    isInstalled() {
      return false;
    }
  };
};

export { rainbowWallet };
